import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
export var TitleModalWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jb8c9d-0"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.gap(1, 'column');
});
export var Title = /*#__PURE__*/styled.h1.withConfig({
  componentId: "sc-jb8c9d-1"
})(["font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";text-transform:capitalize;span{font-weight:300;text-transform:none;}", ""], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.photosModal.title.color;
}, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(24);
}));
export var Reference = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-jb8c9d-2"
})(["font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";color:", ";", ""], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(28);
}, function (props) {
  return props.theme.photosModal.reference.color;
}, mediaMin.mediumBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), function (props) {
  return props.theme.rem(16);
}));